import { render, staticRenderFns } from "./ClassroomDetailTabMyTasks.vue?vue&type=template&id=64480eb3&scoped=true"
import script from "./ClassroomDetailTabMyTasks.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyTasks.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMyTasks.vue?vue&type=style&index=0&id=64480eb3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64480eb3",
  null
  
)

export default component.exports